module.exports = __webpack_public_path__ + "img/section4-img1.cad6e35a.png";